import * as classes from './Header.module.css'
import { Locales } from '../models/locales.model'

const langIcon = new URL('../assets/lang-icon.svg', import.meta.url)
const phoneIcon = new URL('../assets/phone-icon.svg', import.meta.url)
const emailIcon = new URL('../assets/email-icon.svg', import.meta.url)

const Header = ({ email, languageUrl, logo, phone, locale }) => {
  return (
    <header className="container-md">
      <div className={`container-text ${classes.header}`}>
        {logo && <div className={classes.logo}>
          <img src={logo?.file?.url}
               alt={logo?.title}
               width={logo.file?.details?.image?.width}
               height={logo.file?.details?.image?.height}
          />
        </div>}
        <div className={classes.right}>
          {languageUrl &&
          <a href={languageUrl} className={classes.pointer}>
            <img src={langIcon} alt='language' aria-hidden='true' />
            {locale === Locales.EN ? 'Français' : 'English'}
          </a>}
          {phone && <a href={`tel:${phone}`} className={classes.pointer}>
            <img src={phoneIcon} alt='phone' aria-hidden='true' />
            {phone}
          </a>}
          {email && <a href={`mailto:${email}`} className={classes.pointer}>
            <img src={emailIcon} alt='email' aria-hidden='true' />
            {email}
          </a>}
        </div>
      </div>
    </header>
  )
}

export default Header
